import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailCrowFeet({data, img}) {
    return (
        <MeasurementResult type="눈꼬리 주름" description='눈꼬리 주름은 눈을 감았을 때 또는 웃을 때 눈 주변에 형성되는 주름으로 사람의 표정과 표현에 따라 생기는 자연스러운 주름입니다. 주로 웃을 때 나타나는 "웃는 주름"으로도 알려져 있습니다. 눈꼬리 주름은 노화 과정에서 더욱 뚜렷해질 수 있습니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_right &&
                        <img src={img.image_cross_polar_right} />
                        }                
                        {
                        img.image_mark_crows_feet_right &&
                        <img src={img.image_mark_crows_feet_right} />
                        }                                    

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="눈꼬리 주름"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "중간 정도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중증 정도",
                        label: "5"
                    },
                    {
                        value: "중증 정도",
                        label: "6"
                    },
                    {
                        value: "중증 정도",
                        label: "7"
                    },
                ]}
                text={data.degreeText}
                levelFloat={data.levelFloat}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}